import {attachment, params, product} from './state';
import {getAcls} from '../acls/actions';

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer un valor para la variable manufacturers.
 */
export function setManufacturers(state, manufacturers) {
    state.manufacturers = manufacturers;
}

/**
 * Establecer un valor para la variable manufacturers.
 */
export function setManufacturersForm(state, manufacturers_form) {
    state.manufacturers_form = manufacturers_form;
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setShowToModal(state, show) {
    state.modal.show = show;
}

/**
 * Establecer un valor para el atributo step de la variable modal.
 */
export function setStepToModal(state, step) {
    state.modal.step = step;
}

/**
 * Establecer un valor para la variable fds_states.
 */
export function setFdsStates(state, fds_states) {
    state.fds_states = fds_states;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;
}

/**
 * Establecer un valor para la variable languages.
 */
export function setLanguages(state, languages) {
    state.languages = languages;
}

/**
 * Establecer un valor para la variable params.
 */
export function resetParams(state) {

    let acls = getAcls();

    state.params = params();
    state.products = {
        data: []
    };

    if (acls.user.slq_provider_id) {
        state.params.provider_id = acls.user.slq_provider_id;
    }
}


/**
 * Establecer un valor para las variables del modal.
 */
export function resetModal(state) {
    state.product = product();
    state.attachment = attachment();
}

/**
 * Establecer un valor para la variable products.
 */
export function setProducts(state, products) {
    state.products = products;
}

/**
 * Establecer un valor para el atributo page de la variable params.
 */
export function setPageToParams(state, page) {
    state.params.page = page;
}

/**
 * Establecer un valor para la variable providers.
 */
export function setProviders(state, providers) {
    state.providers = providers;
}

/**
 * Establecer un valor para el atributo provider_id de la variable params.
 */
export function setProviderIdToParams(state, provider_id) {
    state.params.provider_id = provider_id;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable product.
 */
export function setProduct(state, product) {
    state.product = product;
}

/**
 * Establecer el valor por defecto de la variable product.
 */
export function resetProduct(state) {
    state.product = product();
}

/**
 * Establecer un valor para la variable attachment.
 */
export function setAttachment(state, attachment) {
    state.attachment = attachment;
}

/**
 * Establecer un valor para el atributo url de la variable attachment.
 */
export function setUrlToAttachment(state, url) {
    state.attachment.url = url;
}

/**
 * Establecer un valor para la variable only_view.
 */
export function setOnlyView(state, only_view) {
    state.only_view = only_view;
}

/**
 * Establecer un valor para el atributo company_id de la variable params.
 */
export function setCompanyIdToParams(state, company_id) {
    state.params.company_id = company_id;
}

/**
 * Establecer el valor por defecto de la variable products.
 */
export function resetProducts(state) {
    state.products = {
        data: []
    };
}
